import template from './location.html';
import controller from './location.controller';
import './location.scss';

let locationComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default locationComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/location.component.js